import { useTranslate } from '@refinedev/core';
import { Typography, Tag, Table } from 'antd';
import type { ContentProductContributorOut } from '@/api/generated/schemas';

const { Title } = Typography;

export const ProductContributorsTab = ({
  contributors,
}: {
  contributors: ContentProductContributorOut[];
}) => {
  const t = useTranslate();

  if (contributors.length === 0) {
    return (
      <Typography.Text type="secondary">
        {t('content_catalog.products.contributors.not_available')}
      </Typography.Text>
    );
  }

  return (
    <>
      <Title level={4}>
        {t('content_catalog.products.contributors.title')}
      </Title>
      <Table<ContentProductContributorOut>
        dataSource={contributors}
        rowKey="position"
        pagination={false}
        size="small"
      >
        <Table.Column
          dataIndex="contributor_id"
          title={t(
            'content_catalog.products.contributors.fields.contributor_id'
          )}
        />
        <Table.Column
          dataIndex="name"
          title={t('content_catalog.products.contributors.fields.name')}
          render={(value: string) => value ?? '-'}
        />
        <Table.Column
          dataIndex="first_name"
          title={t('content_catalog.products.contributors.fields.first_name')}
          render={(value: string) => value ?? '-'}
        />
        <Table.Column
          dataIndex="last_name"
          title={t('content_catalog.products.contributors.fields.last_name')}
          render={(value: string) => value ?? '-'}
        />
        <Table.Column
          dataIndex="role"
          title={t('content_catalog.products.contributors.fields.role')}
          render={(value: string) => (
            <Tag>
              {t(`content_catalog.products.contributor_role.${value}`, {
                defaultValue: value,
              })}
            </Tag>
          )}
        />
        <Table.Column
          dataIndex="voice_type"
          title={t('content_catalog.products.contributors.fields.voice_type')}
          render={(value: string | null) =>
            value ? (
              <Tag>
                {t(`content_catalog.products.voice_type.${value}`, {
                  defaultValue: value,
                })}
              </Tag>
            ) : (
              '-'
            )
          }
        />
        <Table.Column
          dataIndex="position"
          title={t('content_catalog.products.contributors.fields.position')}
        />
      </Table>
    </>
  );
};
